import React, {
  createContext,
  PropsWithChildren,
  useState,
  useEffect,
} from "react";
import { getCatalog } from "@services/catalog";
import { DeviceCatalog } from "@services/catalog/types";
import { useErrorNotification } from "@common/components/Notification";
import { AUTH_USER } from "@common/constants";

type CatalogContextType = DeviceCatalog | undefined;

export const CatalogContext = createContext<CatalogContextType>(undefined);

export const CatalogProvider = (props: PropsWithChildren<{}>) => {
  const [catalog, setCatalog] = useState<CatalogContextType>(undefined);
  const dispatchError = useErrorNotification();

  const fetch = async () => {
    try {
      const token = localStorage.getItem(AUTH_USER);
      if (token) {
        setCatalog(await getCatalog());
      }
    } catch (e) {
      dispatchError(e);
    }
  };
  useEffect(() => {
    if (catalog === undefined) fetch();
  }, [catalog]);

  return (
    <CatalogContext.Provider value={catalog}>
      {props.children}
    </CatalogContext.Provider>
  );
};
